export default "__VITE_ASSET__db59b8ab__"